import { gql } from '@apollo/client'
import { DailyCheckInRewardFragment } from '@src/graphql/fragment/reward'

export default gql`
  query GetMyDailyCheckInCampaigns($input: DailyCheckInCampaignsInput!) {
    getMyDailyCheckInCampaigns(input: $input) {
      bonuses {
        bonusHash
        metaKey
        rewards {
          ...DailyCheckInReward
        }
        status
      }
      campaignID
      days {
        cycle
        date
        day
        isCurrent
        isPast
        status
        earnType
        rewards {
          ...DailyCheckInReward
        }
      }
    }
  }
  ${DailyCheckInRewardFragment}
`
